/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TravellerTypes {
  Unknown = 0,
  Adult = 1,
  Children = 2,
  Student = 3,
  Youth = 64,
  Senior = 69,
  Conscript = 80,
}
